import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const helpCenterSettingsChatConfigurationRoute: InvariantJiraRoute = {
	name: 'helpcenter-settings-chat-configuration',
	path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/chat',
	exact: true,
};
